import PropTypes from 'prop-types';

export const propsVal = () => {
  const val = {
    type: PropTypes.string,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    hideCloseButton: PropTypes.bool,
    disableAnimation: PropTypes.bool,
    fullBleed: PropTypes.bool,
    className: PropTypes.string,
    onCloseButtonClick: PropTypes.any,
    serviceInfo: PropTypes.any,
    note: PropTypes.string,
    log: PropTypes.any,
    children: PropTypes.any,
    logService: PropTypes.any,
    disableVideoAssist: PropTypes.any,
    buttonData: PropTypes.array,
    layout: PropTypes.string,
  };
  return val;
};

export const defaultPropsVal = () => {
  const propVal = {
    hideCloseButton: false,
    disableAnimation: false,
  };
  return propVal;
};

